import formatDate from "core-web/utils/formatDate";
import { getState } from "core-web/state";
import i18next from "i18next";
import transformFlexibleBackground from "theme/libs/wordpress/utils/transformFlexibleBackground";

// Transform the articledata returned from algolia
const transformArticle = (algoliaArticleData, buttonText) => {
    const locale = getState("application").locale;
    const hiddenCategories = ["Uncategorized", "Okategoriserad"];

    const {
        category,
        created: createdAt,
        external_id: id,
        primary_category: primaryCategory,
        settings,
        tags,
        title,
        url,
    } = algoliaArticleData;

    const date = new Date(createdAt * 1000);
    let created = formatDate(date, "d MMMM yyyy", locale);

    if (settings?.date_published?.length) {
        created = settings.date_published;
    }

    return {
        background: transformFlexibleBackground(settings?.image, "image"),
        previewText: settings?.preview_text || "",
        button: {
            buttonTheme: "transparentWhite",
            label: buttonText || i18next.t("read_more"),
            link: url,
        },
        categories: category
            .sort()
            .filter((cat) => hiddenCategories.indexOf(cat) === -1)
            .join(" | "),
        category: primaryCategory,
        created,
        heading: title,
        id,
        link: url,
        tag: (Object.values(tags) || []).sort().join(" | "),
    };
};

export default transformArticle;
